import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchReportedData } from "services/apis";


const initialState = {
  repostedData: [], 
  status: "idle", 
  loading: false,
  error: null,
};


export const getReportedUsers = createAsyncThunk(
  "users/fetchReportedData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchReportedData(); 
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch users data");
    }
  }
);


const reportedDataSlice = createSlice({
  name: "reportedUsers",
  initialState,
  reducers: {
    updateUserStatus: (state, action) => {
      const { id, status } = action.payload;
      const user = state.repostedData.find((u) => u.id === id);
      if (user) {
        user.status = status;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReportedUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.status = "loading";
      })
      .addCase(getReportedUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.repostedData = action.payload; 
        state.status = "succeeded";
      })
      .addCase(getReportedUsers.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.payload; 
      });
  },
});

export const { updateUserStatus } = reportedDataSlice.actions;
export default reportedDataSlice.reducer;